import HttpService from './httpService';
import config from '../../config';

class RedsysApiService extends HttpService {
  async cargarInfoPago({ uid, headquarter }) {
    return this.get(`redsys/info-pago/${uid}`, { params: { headquarter } });
  }

  async iniciarPago({ uid, headquarter, acuerdosAceptados }) {
    return this.post('redsys/iniciar-pago', { uid, headquarter, acuerdosAceptados });
  }

  async cargarInfoCambioTarjeta({ uid, headquarter }) {
    return this.get(`redsys/cambio-tarjeta/info/${uid}`, { params: { headquarter } });
  }

  async iniciarCambioTarjeta({ uid, headquarter }) {
    return this.post('redsys/cambio-tarjeta/iniciar', { uid, headquarter });
  }
}

const redsysApiService = new RedsysApiService(config.REACT_APP_NODE_API);
export default redsysApiService;
